import customHeaders, { getSpace } from '../../../../common/headers';
import { useState, useEffect } from 'react';
import { StepItem } from '../../../../components/StepItem/StepItem';
import {
    DropDownSelector,
    ButtonBasic,
    InputDinamycPlaceholder,
    Checkbox,
    SelectExecutor,
    Tabs,
} from '@lk-gtcom/ecomlab-components'
import useGeneralStore from '../../../../store/general';
import { TitlePage } from '../../../../components/TitlePage/TitlePage';
import { DynamicFormComponent } from '../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAlert } from '../../../../components/Modal/ModalAlert/ModalAlert';
import { OPTIONS_PRIORITY } from '../../../ComponentsCommonTasksLogic/ModalAddTask/ModalAddTask';
import { usePushNotifications } from '../../../../common/pushNotification';
import './ModalDeveloperFunctionality.scss';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../../common/auth';

const btn_tab = [
    { label: 'Сделки', value: 'deal' },
    { label: 'Компании', value: 'company' },
    { label: 'Контакты', value: 'contacts' },
    { label: 'Договора', value: 'contracts' },
    { label: 'Услуги', value: 'services' }
];

const ACTION_OPTIONS = [
    { label: 'Создание', value: 'creation' },
    { label: 'Изменение', value: 'change' },
];

const ModalDeveloperFunctionality = ({ setIsModal }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const client_id = localStorage.getItem('client_id');
    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [isLoadingFile, setIsLoadingFile] = useState(false)

    const [projectData, setProjectData] = useState([])
    const [selectedProject, setSelectedProject] = useState([])
    const [projectPage, setProjectPage] = useState(1);

    const [voronkaData, setVoronkaData] = useState([])
    const [selectedVoronka, setSelectedVoronka] = useState([])
    const [voronkaPage, setVoronkaPage] = useState(1);

    const [stepData, setStepData] = useState([])
    const [selectedStep, setSelectedStep] = useState([])

    const [selectedAction, setSelectedAcrion] = useState(ACTION_OPTIONS[0])

    const [currentStep, setCurrentStep] = useState(1)
    const [isSave, setIsSave] = useState(false)

    const [pageValue, setPageValue] = useState(btn_tab[0]?.value)

    // Данные для записи в сделку
    const [name, setName] = useState(false)
    const [description, setDescription] = useState('')
    const [selectedPriority, setSelectedPriority] = useState({
        label: 'Не указано',
        value: 'Не назначено',
    });
    const [executors, setExecutors] = useState([]);
    const [executorOptions, setExecutorOptions] = useState([]);
    const [tokenProject, setTokenProject] = useState(null)

    // Поля
    const [fields, setFilds] = useState([]);
    const [fieldsFunnel, setFieldsFunnel] = useState([]);

    const [check, setCheck] = useState([])

    const [isModalAlert, setIsModalAlert] = useState(false)
    const [curl, setCurl] = useState('')

    const inputs = [
        {
            label: 'Телефон',
            value: 'phone'
        },
        {
            label: 'E-mail',
            value: 'email'
        },
        ...(pageValue == 'company'
            ? [
                {
                    label: 'Адрес',
                    value: 'address'
                },
            ]
            : []),
    ]

    // Получение токена проекта
    const fetchGetToken = (id) => {
        const url = `https://portals.ecomru.ru/api/crm/projects/token/${id}`
        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then(json => {
                if (json) {
                    setTokenProject(json)
                }
            })
            .catch(handleRequestError)
    }

    // Получение проектов по пространству
    const fetchProjectPreview = (abortController = new AbortController()) => {
        let url = ` https://portals.ecomru.ru/api/crm/projects/?page=${projectPage}&limit=${1000}`

        fetch(url, { headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                const { data, total } = json
                const currentList = data.map(({ id, name }) => ({ label: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, value: id }))
                    ?.filter((id) => id !== -1)
                setProjectData(currentList)
            })
            .catch(handleRequestError);
    };

    // Получение воронок
    const fetchGetBord = () => {
        if (!selectedProject.value) return
        let url = ` https://portals.ecomru.ru/api/crm/funnels/${selectedProject.value}?page=${voronkaPage}&limit=1000`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => {
                const { data, total } = json
                const currentList = data.map(({ id, name }) => ({ label: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, value: id }))
                setVoronkaData(currentList)
            })
            .catch(handleRequestError);
    };

    // Получение колонок по доске
    const fetchAllColumns = (abortController = new AbortController()) => {
        if (!selectedVoronka.value) return
        const url = ` https://portals.ecomru.ru/api/crm/steps/${selectedVoronka.value}`;

        const body = JSON.stringify({
            responsible_list: [],
            author_list: [],
            co_executors_list: []
        })

        fetch(url, { method: 'POST', headers, signal: abortController.signal, body })
            .then(handleTableResponse)
            .then((json) => {
                const { data, total } = json
                const currentList = json.map(({ id, name }) => ({ label: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, value: id }))
                setStepData(currentList)
            });
    };

    // Получение полей проекта
    const fetchGetAdditionalFields = (abortController = new AbortController(), page) => {

        let url;
        if (pageValue == 'contacts') {
            url = ` https://portals.ecomru.ru/api/crm/contacts/get/additional_fields`
        } else if (pageValue == 'company') {
            url = ` https://portals.ecomru.ru/api/crm/companies/get/additional_fields`
        } else {
            url = ` https://portals.ecomru.ru/api/crm/projects/get_additional_field/${selectedProject?.value}`
            if (!selectedProject?.value) return
        }

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                setFilds(json?.map(({ name, id, type, possible_values }) => ({ front_name: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, data_type: type, id: id, possible_values: possible_values, field_source: 'project' })))
            })
            .catch(handleRequestError);
    };

    // Получение полей воронки
    const fetchGetAdditionalFieldsFunnel = ( abortController = new AbortController() ) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/get_additional_field/${selectedVoronka?.value}`

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                setFieldsFunnel(json?.map(({ name, id, type, possible_values, field_source }) =>
                    ({ front_name: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, data_type: type, id: id, possible_values: possible_values, field_source: 'funnel' })))
            })
            .catch(handleRequestError);
        // .finally(() => {
        //     setLoad(false)
        // })
    };

    // Список участников для проекта
    const fetchGetAttendees = (abortController = new AbortController()) => {
        if (!selectedProject?.value) return
        let url = ` https://portals.ecomru.ru/api/crm/projects/attendees/${selectedProject?.value}`

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                const { attendees, author } = json
                const curr = attendees.map((el) => ({ ...el, name: `ID-${el?.id} / ${el?.name}`, executor: el.responsible }))
                console.log(curr)
                setExecutorOptions(curr);
            })
            .catch(handleRequestError);
    };

    const curr_path_excel = () => {
        if (pageValue == 'company') return 'companies'
        if (pageValue == 'deal') return 'deals'
        return pageValue
    }

    // Скачать шаблон цен
    const fetchGetTemplate = async () => {
        const url = ` https://portals.ecomru.ru/api/crm/${curr_path_excel()}/template/excel${pageValue == 'deal' ? `?funnel_id=${selectedVoronka?.value}` : ''}`;

        fetch(url, {  method: 'GET', headers })
            .then((res) => {
                if (!res.ok) throw new Error('Export failed');

                const contentDisposition = res.headers.get('Content-disposition');
                let filename = 'offer_price_parameters.xlsx'; // значение по умолчанию

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }

                return res.blob().then(blob => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    console.error('Export error:', err);
                }
            })
    }

    // Загрузить шаблон
    const handleFileChange = (file, status) => {
        if (!file.target.files[0]) return;
        setIsLoadingFile(true)
        const url = ` https://portals.ecomru.ru/api/crm/${curr_path_excel()}/template/excel${pageValue == 'deal' ? `?step_id=${selectedStep?.value}` : ''}`;

        const formData = new FormData();
        formData.append('file', file.target.files[0]);

        const updatedHeaders = { ...headers };
        delete updatedHeaders['Content-Type'];

        fetch(url, {
            method: 'POST',
            updatedHeaders,
            headers: updatedHeaders,
            body: formData,
        })
            .then(async (res) => {
                const data = await res.json(); // сначала парсим ответ
                if (!res.ok) {
                    const errorMessage = data;
                    addErrorPush(`Ошибка загрузки: ${errorMessage}`);
                    throw new Error(`Upload failed: ${res.statusText}`);
                }
                return res.json();
            })
            .then((data) => addSuccessPush('Успешная загрузка'))
            .catch(handleRequestError)
            .finally(() => setIsLoadingFile(false));
    };

    useEffect(() => {
        if (selectedProject?.value) {
            fetchGetToken(selectedProject.value)
        }
    }, [selectedProject]);

    const onCheck = (id) => {
        let arr = [];
        if (check?.includes(id)) {
            arr = check.filter((el) => el != id);
            setCheck(arr);
        } else {
            setCheck((prev) => [...prev, id]);
        }
    }

    useEffect(() => {
        fetchProjectPreview()
    }, []);

    useEffect(() => {
        fetchGetAttendees()
        setFilds([])
        setCheck([])
        fetchGetAdditionalFields([], pageValue)
    }, [selectedProject, pageValue]);

    useEffect(() => {
        if (pageValue == 'deal') {
            fetchGetAdditionalFieldsFunnel([])
        }
    }, [selectedVoronka]);

    useEffect(() => {
        if (selectedStep.value &&
            selectedProject.value &&
            selectedVoronka.value) {
            setCurrentStep(2)
        } else {
            setCurrentStep(1)
        }
    }, [selectedStep.value, selectedProject.value, selectedVoronka.value]);

    const isDisabledBtn = () => {
        if (pageValue == 'deal') {
            return (!selectedStep.value ||
                !selectedProject.value ||
                !selectedVoronka.value ||
                !executors?.[0]?.id)
        } else {
            return false
        }
    }

    return (
        <>
            {isModalAlert && <ModalAlert
                title={curl}
                copy={true}
                setIsModal={(e) => setIsModalAlert(e)}
            />}

            <ModalComponent
                title='Функционал разработчика'
                onClose={(e) => setIsModal(false)}
                child={
                <div className='modal-developer-functionality__content'>
                    <DropDownSelector
                        options_prop={ACTION_OPTIONS}
                        state={selectedAction}
                        setState={setSelectedAcrion}
                        isClearable={false}
                        placeholder={'Выберите действие'}
                    />

                    <Tabs
                        tabs={btn_tab}
                        pageValue={pageValue}
                        setPageValue={setPageValue}
                        stopRedirect
                    />

                    {<div className='modal-developer-functionality__btn-group'>
                        <ButtonBasic
                            disabled={pageValue === 'deal' && !selectedVoronka?.value}
                            whiteBlue
                            text='Шаблон загрузки Excel'
                            onClick={() => {
                                fetchGetTemplate()
                            }}
                        />


                        <div className='maintaining-marginality__btn-upload'>
                            <ButtonBasic
                                blue
                                text='Загрузить'
                                disabled={pageValue === 'deal' && !selectedStep?.value}
                                loading={isLoadingFile}
                            />

                            {(!(pageValue === 'deal' && !selectedStep?.value)) && <input
                                type="file"
                                id="fileInput"
                                accept=".xls, .xlsx"
                                onChange={handleFileChange}
                            />}
                        </div>
                    </div>}

                    {pageValue == 'deal' && <div className="modal-developer-functionality__content">

                        {(currentStep === 1) && <StepItem
                            title='Шаг 1: Выбери проект, воронку и шаг '
                            description={
                                <>
                                    Заполните все обязательные поля, которые находятся ниже и
                                    нажмите на кнопку “Сохранить”.
                                    <span style={{ color: 'red' }}>
                                        {' '}
                                        Красными звездочками
                                    </span>{' '}
                                    выделены обязательные пункты для заполнения</>}
                        />}

                        <div className={'modal-developer-functionality__fields'}>
                            <DropDownSelector
                                options_prop={projectData}
                                state={selectedProject}
                                setState={setSelectedProject}
                                required={true}
                                placeholder={'Проект'}
                                isClearable={false}
                                disabled={isSave}
                                onBlur={() => {
                                    fetchGetBord()
                                }}
                            />

                            <DropDownSelector
                                options_prop={voronkaData}
                                state={selectedVoronka}
                                setState={setSelectedVoronka}
                                required={true}
                                isClearable={false}
                                placeholder={'Воронка'}
                                disabled={!selectedProject?.value}
                                onBlur={() => {
                                    fetchAllColumns()
                                }}
                            />

                            <DropDownSelector
                                options_prop={stepData}
                                state={selectedStep}
                                setState={setSelectedStep}
                                required={true}
                                isClearable={false}
                                placeholder={'Шаг'}
                                disabled={!selectedProject?.value || !selectedVoronka?.value}
                            />
                        </div>

                        {(currentStep === 2) &&
                            <>
                                <StepItem
                                    title='Шаг 2: Выберите поля и назначьте ответственного'
                                />

                                <TitlePage
                                    medium
                                    title='Назначьте ответственного'
                                />

                                <SelectExecutor
                                    executors={executors}
                                    setExecutors={(e) => {
                                        setExecutors(e);
                                    }}
                                    executorOptions={executorOptions}
                                    title="Ответственный"
                                    placeholder="Назначить"
                                />

                                <TitlePage
                                    medium
                                    title='Выберите поля'
                                />

                                <div className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes('name')}
                                        onChange={() => onCheck('name')}
                                    />

                                    <InputDinamycPlaceholder
                                        changeValue={name}
                                        onChange={(e) => setName(e)}
                                        placeholder={<><span style={{ fontWeight: 600 }}>ID-name</span> Добавьте название</>}
                                        size="s"
                                        style={{
                                            maxWidth: '300px',
                                        }}
                                    />
                                </div>

                                <div className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes('description')}
                                        onChange={() => onCheck('description')}
                                    />

                                    <InputDinamycPlaceholder
                                        changeValue={description}
                                        onChange={(e) => setDescription(e)}
                                        placeholder={<><span style={{ fontWeight: 600 }}>ID-name</span> Добавьте описание</>}
                                        size="s"
                                        style={{
                                            maxWidth: '300px',
                                        }}
                                    />
                                </div>

                                <div className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes('contact')}
                                        onChange={() => onCheck('contact')}
                                    />

                                    <InputDinamycPlaceholder
                                        onChange={(e) => { }}
                                        placeholder={<><span style={{ fontWeight: 600 }}>ID-contact</span> Контакт</>}
                                        size="s"
                                        style={{
                                            maxWidth: '300px',
                                        }}
                                    />
                                </div>

                                <div className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes('company')}
                                        onChange={() => onCheck('company')}
                                    />

                                    <InputDinamycPlaceholder
                                        onChange={(e) => { }}
                                        placeholder={<><span style={{ fontWeight: 600 }}>ID-company</span> Компания</>}
                                        size="s"
                                        style={{
                                            maxWidth: '300px',
                                        }}
                                    />
                                </div>

                                <div
                                    className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes('priority')}
                                        onChange={() => onCheck('priority')}
                                    />

                                    <DropDownSelector
                                        options_prop={OPTIONS_PRIORITY}
                                        placeholder="Приоритет"
                                        isClearable={false}
                                        value={selectedPriority}
                                        defaultValue={selectedPriority}
                                        state={selectedPriority}
                                        setState={(e) => {
                                            setSelectedPriority(e);
                                        }}
                                    />
                                </div>

                                <DynamicFormComponent
                                    productTemporary={[...fields || [], ...fieldsFunnel || []]}
                                    checkbox={true}
                                    check={check}
                                    setCheck={setCheck}
                                />
                            </>
                        }
                    </div>}

                    {(pageValue == 'contacts' || pageValue == 'company')
                        &&
                        <div className="modal-developer-functionality__content">

                            <TitlePage
                                medium
                                title='Выберите поля'
                            />

                            <InputDinamycPlaceholder
                                placeholder={<><span style={{ fontWeight: 600 }}>ID-name</span> Добавьте название</>}
                                size="s"
                                required
                            />

                            {inputs.map(({ label, value }) => {
                                return <div className={'modal-developer-functionality__checkbox-container'}>
                                    <Checkbox
                                        value={check?.includes(value)}
                                        onChange={() => onCheck(value)}
                                    />

                                    <InputDinamycPlaceholder
                                        onChange={(e) => (e)}
                                        placeholder={<><span style={{ fontWeight: 600 }}>{`ID-${value}`}</span> {label}</>}
                                        size="s"
                                    />
                                </div>
                            })}

                            <DynamicFormComponent
                                productTemporary={fields}
                                checkbox={true}
                                check={check}
                                setCheck={setCheck}
                            />
                        </div>}



                    <div className="modal-developer-functionality__btn-container">
                        <ButtonBasic
                            green
                            disabled={isDisabledBtn()}
                            size='56px'
                            text='Сформировать'
                            onClick={(e) => {
                                let value_fields = ''
                                let curl_string = ''
                                let arr_fields = fields.concat(fieldsFunnel || [])

                                arr_fields.forEach((el) => {
                                    if (check?.includes(el?.id)) {
                                        value_fields = value_fields + (el?.field_source == 'funnel' ? '&ff_' : '&f_') + el?.id + `=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ`
                                    }
                                })

                                const isField = check?.length ? value_fields : ''
                                let isName = '?name=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ'
                                let isDescription = check?.includes('description') ? '?description=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let isCompany = check?.includes('company') ? '?company=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let isContact = check?.includes('contact') ? '?contact=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let isPriority = check?.includes('priority') ? `?priority=${selectedPriority?.value}` : ''
                                let isAuthor = `&author=${client_id}`
                                let isPhone = check?.includes('phone') ? '&phone=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let isEmail = check?.includes('email') ? '&email=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let isAddress = check?.includes('address') ? '&address=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ' : ''
                                let action = selectedAction?.value == 'creation' ? 'create' : 'update'

                                if (pageValue == 'deal') {
                                    let name_value = check?.includes('name') ? `&name=ВВЕДИТЕ_СВОЕ_ЗНАЧЕНИЕ` : ''
                                    curl_string = ` https://portals.ecomru.ru/api/crm/deals/${action}?step_id=${selectedStep.value}&token=${tokenProject}&author=${client_id}&responsible=${executors?.[0]?.id}${isDescription}${name_value}${isCompany}${isContact}${isPriority}${isField}`
                                } else if (pageValue == 'contacts') {
                                    curl_string = ` https://portals.ecomru.ru/api/crm/contacts/${action}/by_get${isName}${isPhone}${isEmail}${isField}`
                                } else {
                                    curl_string = ` https://portals.ecomru.ru/api/crm/companies/${action}/by_get${isName}${isAuthor}${isPhone}${isEmail}${isAddress}${isField}`
                                }
                                setCurl(curl_string)
                                setIsModalAlert(true)
                            }}
                        />
                    </div>
                </div>}
            />
        </>
    );
};

export { ModalDeveloperFunctionality };
